<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col :cols="isMobile ? 12 : 7">
        <h1
          class="mb-3"
          :class="{ 'text-h6': isMobile, 'text-h5': !isMobile }"
          v-html="$t('campaignPeriod.title') + ' (' + advertiser.advertiserName + ')'"
        ></h1>
      </v-col>
      <v-col :cols="isMobile ? '6' : '5'" class="text-right">
        <v-btn color="light-blue darken-1 text-white" @click="clickSubmissionConfirmationCampaignList()">
          {{ $t('submissionConfirmationCreativeSetting.buttonCampaignDeliveryStatus') }}
        </v-btn>
      </v-col>
      <v-col class="text-right" :cols="isMobile ? 6 : 12">
        <v-btn color="light-blue darken-1 text-white" :disabled="disableSelectDowmloadButton" @click="clickCreativeReport()"
          >{{ $t('creativeReport.buttonToCreativeReport') }}</v-btn
        >
      </v-col>
      <v-col cols="12" v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
      <v-col cols="6" md="4">
        <v-select
          v-model="selectedDeliveryMonth"
          :items="deliveryMonths"
          item-title="label"
          item-value="value"
          :label="$t('commons.form.select.measureperiod.yearmonth')"
          class="select-digestives"
          @update:modelValue="previewPeriodList()"
          return-object
          variant="underlined"
        ></v-select>
      </v-col>
      <v-col cols="6" md="6">
        <v-text-field v-model="inputCampaignName" label="キャンペーン名" @change="previewPeriodList()" variant="underlined"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-menu offset-y>
          <template v-slot:activator="{ props }">
            <v-btn v-bind:disabled="disableSelectDowmloadButton" color="light-green darken-1 text-white" v-bind="props">
              <v-icon>mdi-download-multiple</v-icon>
              {{ $t('campaignPeriod.reportDownload.button') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in menuItems" :key="index" @click="clickItem(item)">
              <v-list-item-title>
                <v-icon>mdi-download</v-icon>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col cols="12">
        <v-data-table
          :headers="campaignPeriodListHeaders"
          :items="campaignPeriodList"
          :sort-by="sortBy"
          :sort-desc="false"
          :items-per-page="-1"
          :hide-default-header="isMobile"
          :no-data-text="$t('commons.table.no.data.text')"
          hide-default-footer
          class="elevation-3 campaign-list"
          :class="{ mobile: isMobile }"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-center caption">
                <span class="link" @click="navigateToReport(advertiser.agencyId, advertiser.advertiserId, props.item.campaignPeriodId, props.item.cpxreportType)">{{ props.item.campaignPeriodStartAt }} - {{ props.item.campaignPeriodEndAt }}</span>
              </td>
              <td class="text-left break-word-cell caption">{{ props.item.campaignName }}</td>
              <td class="text-center caption">{{ props.item.cpxreportType }}</td>
            </tr>
            <tr v-else>
              <td @click="navigateToReport(advertiser.agencyId, advertiser.advertiserId, props.item.campaignPeriodId, props.item.cpxreportType)">
                <v-row align="center" justify="center">
                  <v-col cols="11">
                    <ul class="flex-content">
                      <li class="flex-item" :data-label="$t('campaignPeriod.headers.periodName')">
                        {{ props.item.campaignPeriodStartAt }} - {{ props.item.campaignPeriodEndAt }}
                      </li>
                      <li class="flex-item word-break" :data-label="$t('campaignPeriod.headers.campaignName')">{{ props.item.campaignName }}</li>
                      <li class="flex-item" :data-label="$t('campaignPeriod.headers.cpxreportType')">{{ props.item.cpxreportType }}</li>
                    </ul>
                  </v-col>
                  <v-col cols="1">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'CampaignPeriodList',
  props: ['advertiserId'],
  data: function () {
    return {
      sortBy: [{ key: '_sortPeriodValue', order: 'asc' }],
      selectedDeliveryMonth: {},
      deliveryMonths: [],
      inputCampaignName: '',
      disableSelectDowmloadButton: true,
      campaignPeriodListHeaders: [
        {
          title: this.$t('campaignPeriod.headers.periodName'),
          align: 'center',
          key: '_sortPeriodValue',
          width: '250',
          sortable: true,
          sort: (a, b) => {
            const parseTimestamps = (item) => {
              const parts = item.split('-');
              const start = Number(parts[0]);
              const end = Number(parts[1]);

              if (isNaN(start) || isNaN(end)) {
                return { start: Infinity, end: Infinity };
              }
              return { start, end };
            };
            const periodA = parseTimestamps(a);
            const periodB = parseTimestamps(b);
            // 開始タイムスタンプで比較
            const compareStart = periodA.start - periodB.start;

            if (compareStart !== 0) {
              // 開始タイムスタンプが異なる場合、その差を返す
              return compareStart;
            } else {
              // 開始タイムスタンプが同じ場合、終了タイムスタンプで比較
              return periodA.end - periodB.end;
            }
          }
        },
        {
          title: this.$t('campaignPeriod.headers.campaignName'),
          align: 'center',
          key: 'campaignName'
        },
        {
          title: this.$t('campaignPeriod.headers.cpxreportType'),
          align: 'center',
          key: 'cpxreportType',
          width: '100'
        }
      ],
      advertiser: [],
      campaignPeriodList: [],
      isMobile: false,
      agencyId: undefined,
      errorMessage: undefined,
      menuItems: [{ title: this.$t('campaignPeriod.reportDownload.menuTitle.campaignPeriod'), click: 'campaignPeriod' }]
    }
  },
  methods: {
    ...mapActions('deliveryMonth', ['getMonthAllList', 'setSelectedDeliveryMonth']),
    ...mapActions('period', ['getPeriodList']),
    ...mapActions('bundleDownload', ['getDownload']),
    initialize: function () {
      // カレンダーの初期化とリストの初期表示
      this.getMonthAllList().then((result) => {
        this.deliveryMonths = result
        const params = 'deliveryMonth/selectedDeliveryMonth'
        // 当月を指定する（全てが存在するから配列２）
        var defaultDeliveryMonth = result[2]
        if (this.$route.query.yearMonth !== undefined) {
          for (var i in result) {
            if (this.$route.query.yearMonth === result[i].value) {
              defaultDeliveryMonth = result[i]
            }
          }
        } else if (this.$store.getters[params] !== undefined) {
          defaultDeliveryMonth = this.$store.getters[params]
        }
        this.selectedDeliveryMonth = defaultDeliveryMonth
        this.previewPeriodList()
      })
    },
    previewPeriodList: function () {
      const jwtToken = this.$store.getters['auth/jwtToken']
      const deliveryMonth = this.selectedDeliveryMonth.value
      this.setSelectedDeliveryMonth(this.selectedDeliveryMonth)
      const advertiserId = this.advertiserId
      const campaignName = this.inputCampaignName

      // URLにパラメータを付与
      var url = location.href
      if (url.indexOf('?') !== -1) {
        url = url.substring(0, url.indexOf('?'))
      }
      this.$router.replace({
        query: { yearMonth: deliveryMonth }
      })
      .catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router replace error:', err);
        }
      });

      this.getPeriodList({
        privateCode: process.env.ProjectCode,
        advertiserId: advertiserId,
        deliveryMonth: deliveryMonth,
        campaignName: campaignName,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.campaignPeriodList = []
            this.advertiser = {}
            return
          }
          this.advertiser = result.advertiser
          this.campaignPeriodList = result.campaignPeriodList
            .filter(item => item !== undefined && item !== null)
            .map(item => {
              // ソートキーの生成
              const startMoment = moment(item.campaignPeriodStartAt, 'YYYY/MM/DD')
              const endMoment = moment(item.campaignPeriodEndAt, 'YYYY/MM/DD')

              return {
                ...item,
                _sortPeriodValue: startMoment + '-' + endMoment
              };
            })
          this.agencyId = result.advertiser.agencyId
        })
        .catch((err) => {
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
    },
    clickItem(item) {
      if (item.click === 'campaignPeriod') {
        this.clickCampaignPeriodDownload()
      }
    },
    clickCampaignPeriodDownload: function () {
      const jwtToken = this.$store.getters['auth/jwtToken']
      const deliveryMonth = this.selectedDeliveryMonth.value
      this.setSelectedDeliveryMonth(this.selectedDeliveryMonth)
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      let paramCampaignPeriodId = []
      for (const campaignPeriod of this.campaignPeriodList) {
        paramCampaignPeriodId.push(campaignPeriod.campaignPeriodId)
      }
      const paramCampaignPeriodIds = paramCampaignPeriodId.join('-')
      // CPX レポート画面では CSV ダウンロード時の文字コードは Shift_JIS とする
      const charset = 'Shift_JIS'

      this.getDownload({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        deliveryMonth: deliveryMonth,
        campaignPeriodIds: paramCampaignPeriodIds,
        charset: charset,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
        })
        .catch((err) => {
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
    },
    clickCreativeReport: function () {
      let campaignIds = new Set()
      for (const campaignPeriod of this.campaignPeriodList) {
        campaignIds.add(campaignPeriod.campaignId)
      }
      const dateFormat = 'YYYYMMDD'
      const cIds = Array.from(campaignIds).join(',')
      const start = moment(this.selectedDeliveryMonth.value + '01', dateFormat)
      const end = moment(start).endOf('month')
      this.$router.push({
        path: `/creativeReportList/${this.agencyId}/${this.advertiserId}`,
        query: {
          cIds: cIds,
          from: start.format(dateFormat),
          to: end.format(dateFormat)
        }
      })
    },
    
    
    onResize: function () {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    navigateToReport: function (agencyId, advertiserId, campaignPeriodId, cpxreportType) {
      if (cpxreportType === 'CPC') {
        this.$router.push(`/cpcReport/${agencyId}/${advertiserId}/${campaignPeriodId}`)
      } else {
        this.$router.push(`/cpaReport/${agencyId}/${advertiserId}/${campaignPeriodId}`)
      }
    },
    clickSubmissionConfirmationCampaignList: function () {
      this.$router.push(`/campaignLanding/counts/${this.agencyId}/${this.advertiserId}`)
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    next()
  },
  mounted: function () {
    this.initialize()
  },
  computed: {},
  watch: {
    campaignPeriodList: function (campaignPeriodIds) {
      // 計測期間が「全て」又はデータが存在しない場合は、ダウンロードボタンは非活性
      if (campaignPeriodIds[0] === undefined || this.selectedDeliveryMonth.value === '000000') {
        this.disableSelectDowmloadButton = true
      } else {
        this.disableSelectDowmloadButton = false
      }
    }
  }
}
</script>
<style scoped>
.campaign-list .break-word-cell {
  max-width: 500px;
  word-wrap: break-word;
}
</style>
